import React, { useEffect, useState } from 'react'
import {
  VictoryChart,
  VictoryLine,
  VictoryTheme,
  VictoryTooltip,
  VictoryAxis,
  VictoryVoronoiContainer,
  VictoryArea
} from 'victory'
import { useCalc } from '../../context/CalcContext'
import { axisStyleX, axisStyleY, toolTipStyle } from '../../util/chartStyles'
import * as styles from '../../styles/ChartContainer.module.scss'

const uncertaintyYellow = '#fff5c1'

const Growth = () => {
  const { dataSet, dataSetBase, dataSetUpper, dataSetLower } = useCalc()

  return (
    <div className={styles.chartContainer}>
      <h3>Revenue Projection (MRR)</h3>
      <div className={styles.disableMouse}></div>
      <VictoryChart
        padding={{ top: 0, bottom: 45, left: 62, right: 10 }}
        height={340}
        theme={VictoryTheme.grayscale}
        containerComponent={
          <VictoryVoronoiContainer
            voronoiBlacklist={['areaTop', 'areaBottom', 'blackLine']}
            labels={({ datum }) =>
              `${
                '€ ' +
                (
                  Math.round(parseInt(datum.y) / 10000) * 10000
                ).toLocaleString() +
                ' \n by ' +
                datum.x +
                ' months'
              }`
            }
            // labelComponent
            labelComponent={
              <VictoryTooltip
                style={toolTipStyle}
                cornerRadius={4}
                flyoutPadding={6}
              />
            }
          />
        }
      >
        <VictoryArea
          name="areaTop"
          style={{
            data: {
              stroke: uncertaintyYellow,
              strokeWidth: '0px',
              fill: uncertaintyYellow
            },
            parent: { border: '2px solid #ccc' }
          }}
          data={dataSetUpper}
        />
        <VictoryArea
          name="areaBottom"
          style={{
            data: {
              stroke: uncertaintyYellow,
              strokeWidth: '0px',
              fill: '#fff'
            },
            parent: { border: '2px solid #ccc' }
          }}
          data={dataSetLower}
        />
        <VictoryAxis
          dependentAxis
          style={axisStyleX}
          // domain={{ y: [0, 40] }}
          tickFormat={(y) => {
            return '€ ' + (y / 1000).toLocaleString() + 'k'
          }}
        />
        <VictoryAxis
          independentAxis
          style={axisStyleY}
          crossAxis
          tickValues={[0, 12, 24]}
          scale={{ x: 'time' }}
          tickFormat={(x) => {
            if (x === 0) {
              return 'Now'
            }
            return x / 12 + ' years'
          }}
        />
        <VictoryLine
          style={{
            data: { stroke: '#fee100', strokeWidth: '3px' },
            parent: { border: '2px solid #ccc' }
          }}
          data={dataSet}
        />
        <VictoryLine
          name="blackLine"
          style={{
            data: { stroke: '#000', strokeWidth: '3px' },
            parent: { border: '2px solid #ccc' }
          }}
          data={dataSetBase}
        />
      </VictoryChart>
      <div className={styles.chartLegend}>
        <span>With Fejron</span>
        <span>Without Fejron</span>
      </div>
    </div>
  )
}

export default Growth
